import api from 'api'

export type DeleteRequirementQuestionParams = {
  requirementId: number
  questionId: number
}

export const deleteRequirementQuestion = async ({
  requirementId,
  questionId,
}: DeleteRequirementQuestionParams): Promise<void> => {
  await api.delete(`/admin/requirement/${requirementId}/question/${questionId}`)
}
